<div class="col-sm-12" style="z-index: 999;">
  <div class="cat__footer">
    <div class="cat__footer__top">
      <div class="row">
        <div class="col-lg-12">
          <div class="row footer-text">
            <div class="col-sm-12 version">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

